import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";
import { useToast } from "@/composables/useToast";
import { updateEstadoPago, updateEstadoPagoEquipo } from "@/services/InscripcionesService";

// Una inscripción o, en equipos y parejas, el equipo entero

export default /*#__PURE__*/_defineComponent({
  __name: 'InterruptorPago',
  props: {
    esPago: {},
    idInscripcion: {},
    idEquipo: {}
  },
  emits: ["cambiado"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { triggerToast } = useToast();
const guardando = ref(false);
const pagado = computed(() => (props.esPago ?? "").toUpperCase() === "SI");

const cambiar = async (valor: boolean | null) => {
  const esPago = valor ? "SI" : "NO";
  guardando.value = true;
  try {
    if (props.idEquipo) await updateEstadoPagoEquipo({ idEquipo: props.idEquipo, esPago });
    else if (props.idInscripcion) await updateEstadoPago({ idInscripcion: props.idInscripcion, esPago });
    else return;
    emit("cambiado", esPago);
    triggerToast("success", esPago === "SI" ? "Marcado como pagado." : "Marcado como no pagado.");
  } catch (error) {
    console.error("Error actualizando el pago:", error);
    triggerToast("error", "No se ha podido cambiar el pago.");
  } finally {
    guardando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex-shrink-0",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_v_switch, {
      "model-value": pagado.value,
      color: "success",
      density: "compact",
      "hide-details": "",
      loading: guardando.value,
      disabled: guardando.value,
      class: "interruptor",
      "onUpdate:modelValue": cambiar
    }, {
      label: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-body-2", pagado.value ? 'text-success' : 'text-warning'])
        }, _toDisplayString(pagado.value ? "Pagado" : "No pagado"), 3)
      ]),
      _: 1
    }, 8, ["model-value", "loading", "disabled"])
  ]))
}
}

})